import React from 'react';
import { IntlShape } from 'react-intl';
import { Link } from 'react-router-dom';

import { Award } from 'interfaces';
import { AppLocale } from 'constant';

import awardsDataRaw from 'data/awards.json';

import { getSong } from './getSong';
import { getAlbum } from './getAlbum';

const awardsData: Award[] = awardsDataRaw as unknown as Award[];

const getNominee = (award: Award, locale: AppLocale, intl: IntlShape) => {
  const variables = {
    song: award.nomineeType === 'song' ? (
      <Link to={getSong(award.nominee, locale, 'link')}>
        {getSong(award.nominee, locale, 'name')}
      </Link>
    ) : '',
    album: award.nomineeType === 'album' ? (
      <Link to={getAlbum(award.nominee, false, locale, 'link')}>
        {getAlbum(award.nominee, false, locale, 'name')}
      </Link>
    ) : ''
  };

  switch (award.nomineeType) {
    case 'song': {
      return intl.formatMessage({ id: 'history.nominee.song' }, { ...variables });
    }
    case 'band': {
      return intl.formatMessage({ id: 'history.nominee.band' }, { ...variables });
    }
    case 'album': {
      return intl.formatMessage({ id: 'history.nominee.album' }, { ...variables });
    }
  }
}

export const getAwardDetails = (awardId: string, locale: AppLocale, intl: IntlShape) => {
  const award = awardsData.filter((album) => album.id === awardId)[0];

  return {
    result: award.won ? intl.formatMessage({ id: 'history.nominee.result.win' }) : intl.formatMessage({ id: 'history.nominee.result.nomination' }),
    ceremony: intl.formatMessage({ id: `awards.table.ceremony.${award.ceremonyId}` }),
    category: intl.formatMessage({ id: `awards.table.category.${award.categoryId}` }),
    nominee: getNominee(award, locale, intl),
    year: award.year
  };
}
